import { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field, Form, FormikProvider, useFormik } from "formik";
import CommonReactTable from "./CommonUtils/CommonReactTable";
import { CommonAxiosGet } from "./CommonUtils/CommonAxios";
import { config } from "./CommonUtils/CommonURLS";
import { Modal, } from "react-bootstrap";
import { Box, Typography } from '@mui/material';
import * as bie from "react-bootstrap";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
function CollegeFinancialContent({ selectedtab }) {


    const [rusaData, setRusaData] = useState([]);
    const [errormsg, setErrormsg] = useState(null);

    const RusaIFormik = useFormik({
        initialValues: {
            phasestatus: "",
            univcoll: "",
            clgname: ""
        },

    });

    // ---------------- API CALL ----------------
    function GetRusaIDetails(distcode) {

        if (!distcode) {
            return
        }
        let url = `${config.url.API_URL}getRUSA1and2data?distId=${distcode}`;

        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01" && res?.data?.data?.length > 0) {
                setRusaData(res.data.data);
                setErrormsg(true);
            } else {
                setRusaData([]);
                setErrormsg(false);
            }
        });
    }


    const RusaIColumns = [
        {
            id: "sno",
            header: "Sl.No",
            meta: { align: "center" },
            cell: info => info.row.index + 1
        },
        {
            id: "college",
            header: "Institute Name",
            accessorKey: "inst_name",
            meta: { align: "left" },   // 👈 THIS controls alignment
            cell: info => {
                const { inst_name, aishe_code } = info.row.original;
                return (


                    // <span type="button" className="text-hover"


                    //     onClick={() => {
                    //         GetCollegeData(aishe_code);
                    //         setModal(true);
                    //         setClgname(inst_name);
                    //     }}
                    //     style={{
                    //         color: "#0d6efd",
                    //         // textDecoration: "underline",
                    //         cursor: "pointer",
                    //         border: "0px"
                    //     }}
                    // >
                    //     {inst_name}
                    // </span>

                    <span
                        role="button"
                        tabIndex={0}
                        className="text-hover"
                        onClick={() => {
                            GetCollegeData(aishe_code);
                            setModal(true);
                            setClgname(inst_name);
                        }}
                        onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                                GetCollegeData(aishe_code);
                                setModal(true);
                                setClgname(inst_name);
                            }
                        }}
                        style={{
                            color: "#0d6efd",
                            cursor: "pointer",
                            textDecoration: "underline"
                        }}
                    >
                        {inst_name}
                    </span>

                );
            }
        }



    ];


    const [modal, setModal] = useState(false);
    const [Clgname, setClgname] = useState('');

    const [clgdata, setClgdata] = useState([]);
    function GetCollegeData(clgcode) {

        if (!clgcode) {
            return
        }
        const url = `${config.url.API_URL}getDetailsByInst?aisheCode=${clgcode}`;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === "01") {
                setClgdata(res.data.getDtls || []);
                // seterror(true)
            } else {
                setClgdata([]);
                // seterror(false)
            }
        });
    }
    const d = clgdata[0] || {};


    const [distlist, setDistlist] = useState([]);

    const fetchDistList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.API_URL}getDistrictsUsha`
        );
        setDistlist(res?.data?.scode === "01" ? res.data.getDistricts : []);
    };

    useEffect(() => {
        GetRusaIDetails();
        fetchDistList();
    }, [])



    return (
        <>
            <FormikProvider value={RusaIFormik}>
                <Form onSubmit={RusaIFormik.handleSubmit} onChange={RusaIFormik.onChange}>
                    <Modal show={modal} onHide={() => setModal(false)} className="financial-report-model" size="xl" centered backdrop="static" >
                        <Modal.Header closeButton></Modal.Header>
                        <Modal.Body>
                            <div className="graphical-bar-chart">
                                <div>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "12px",
                                            marginBottom: "10px",
                                        }}
                                    >
                                        <h3
                                            style={{
                                                margin: 0,
                                                fontSize: "20px",
                                                fontWeight: "700",
                                                color: "#4E1E03",
                                                letterSpacing: "0.5px",
                                            }}
                                        >
                                            {Clgname}  - Graphical Representation of Institution Wise Financial Details
                                        </h3>
                                    </div>
                                </div>



                                {clgdata?.length > 0 && (
                                    <Box sx={{ display: "flex", flexDirection: "column", gap: 6, mt: 4 }}>
                                        {clgdata?.map((item, index) => {

                                            /* ================= SIDE DETAILS ================= */
                                            const sideDetails = [
                                                {
                                                    label: "Total Approved",
                                                    Total: item?.total_amount_approved,
                                                    State: item?.state_share_approved,
                                                    Central: item?.central_share_approved,
                                                },
                                                {
                                                    label: "Total Utilised",
                                                    Total: item?.total_amount_utilised,
                                                    State: item?.state_share_utilised,
                                                    Central: item?.central_share_utilised,
                                                },
                                                {
                                                    label: "Remaining Balance",
                                                    Total: item.total_amount_approved - item.total_amount_utilised,
                                                    State: item.state_share_approved - item.state_share_utilised,
                                                    Central: item.central_share_approved - item.central_share_utilised,
                                                },
                                            ];

                                            /* ================= CHART DATA ================= */
                                            const categories = ["Approved", "Utilised"];

                                            const stateData = [
                                                item?.state_share_approved,
                                                item?.state_share_utilised,
                                            ];

                                            const centralData = [
                                                item?.central_share_approved,
                                                item?.central_share_utilised,
                                            ];

                                            /* ================= HIGHCHART OPTIONS ================= */
                                            const barOptions = {
                                                chart: {
                                                    type: "column",
                                                    height: 380,
                                                },

                                                title: { text: null },

                                                xAxis: {
                                                    categories,
                                                    labels: {
                                                        style: {
                                                            fontSize: "14px",
                                                            fontWeight: "600",
                                                        },
                                                    },
                                                },

                                                yAxis: {
                                                    min: 0,
                                                    title: {
                                                        text: "Amount (in Lakhs)",
                                                        style: { fontWeight: "bold" },
                                                    },
                                                    stackLabels: {
                                                        enabled: true,
                                                        formatter: function () {
                                                            /* eslint-disable react/no-this-in-sfc */

                                                            return this?.total; // NOSONAR - Highcharts formatter requires 'this' context
                                                            /* eslint-enable react/no-this-in-sfc */


                                                        },
                                                        style: {
                                                            fontWeight: "bold",
                                                            color: "#000",
                                                        },
                                                    },
                                                },

                                                legend: {
                                                    align: "center",
                                                    verticalAlign: "top",
                                                    layout: "horizontal",
                                                },

                                                tooltip: {
                                                    shared: true,
                                                    formatter: function () {
                                                        /* eslint-disable react/no-this-in-sfc */

                                                        // let s = `<b>${this.x}</b><br/>`;// NOSONAR - Highcharts formatter requires 'this' context
                                                        let s = `<b>${Clgname}</b><br/>`; // Show college name instead of index


                                                        this.points.forEach(p => { // NOSONAR - Highcharts formatter requires 'this' context
                                                            s += `${p.series.name}: <b>${p.y.toFixed(2)} L</b><br/>`;// NOSONAR - Highcharts formatter requires 'this' context
                                                        });
                                                        return s;// NOSONAR - Highcharts formatter requires 'this' context
                                                        /* eslint-enable react/no-this-in-sfc */

                                                    },
                                                },

                                                plotOptions: {
                                                    column: {
                                                        stacking: "normal",
                                                        borderRadius: 4,
                                                        dataLabels: {
                                                            enabled: true,
                                                            formatter: function () {
                                                                return this.y.toFixed(2); // NOSONAR - Highcharts formatter requires 'this' context
                                                            },
                                                        },
                                                    },
                                                },

                                                series: [
                                                    {
                                                        name: "State Share",
                                                        data: stateData,
                                                        color: "#96d1b7",
                                                    },
                                                    {
                                                        name: "Central Share",
                                                        data: centralData,
                                                        color: "#055832",
                                                    },
                                                ],

                                                credits: { enabled: false },
                                            };

                                            return (
                                                <Box key={index}>
                                                    {/* ================= PHASE HEADING ================= */}
                                                    <Typography
                                                        variant="h5"
                                                        sx={{
                                                            mb: 2,
                                                            fontWeight: 700,
                                                            color: "#4E1E03",
                                                        }}
                                                    >
                                                        {item?.rusa_phase}
                                                    </Typography>

                                                    <Row>
                                                        {/* ================= BAR CHART ================= */}
                                                        <Col xs={12} md={8}>
                                                            <HighchartsReact
                                                                highcharts={Highcharts}
                                                                options={barOptions}
                                                            />
                                                        </Col>

                                                        {/* ================= SIDE DETAILS ================= */}
                                                        <Col xs={12} md={4}>
                                                            {sideDetails?.map((d) => (
                                                                <Box
                                                                    key={d.label}
                                                                    sx={{
                                                                        mb: 2,
                                                                        p: 1.5,
                                                                        borderRadius: 2,
                                                                        backgroundColor: "#fafafa",
                                                                        boxShadow: "0 1px 4px rgba(0,0,0,0.12)",
                                                                    }}
                                                                >
                                                                    <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
                                                                        {d.label}:{" "}
                                                                        <span
                                                                            style={{
                                                                                color:
                                                                                    d.label === "Remaining Balance" && d.Total < 0
                                                                                        ? "red"
                                                                                        : "#0b5d1e",
                                                                            }}
                                                                        >
                                                                            {(d.Total / 100000).toFixed(2)} L
                                                                        </span>
                                                                    </Typography>

                                                                    <Typography variant="body2">
                                                                        {/* State: <b>{(d.State / 100000).toFixed(2)} L</b> */}
                                                                        State: <b>{d.State} </b>

                                                                    </Typography>

                                                                    <Typography variant="body2">
                                                                        Central: <b>{d.Central}</b>
                                                                    </Typography>
                                                                </Box>
                                                            ))}
                                                        </Col>
                                                    </Row>
                                                </Box>
                                            );
                                        })}
                                    </Box>
                                )}



                            </div>
                        </Modal.Body>



                    </Modal>

                    <bie.Row className="align-items-center g-1">
                        <bie.Col xxl={2} xl={2} lg={2} md={3} sm={4} xs={5}>
                            <label className="form-label-common">Select District :</label>
                        </bie.Col>

                        <bie.Col xxl={4} xl={4} lg={4} md={6} sm={8} xs={7}>
                            <Field
                                as="select"
                                name="dist"
                                className="form-control form-control-md"
                                onChange={(e) => {
                                    GetRusaIDetails(e.target.value);
                                }}
                            >
                                <option value="">---select---</option>
                                {distlist?.map((d) => (
                                    <option key={d.dist_code} value={d.dist_code}>
                                        {d.dist_name}
                                    </option>
                                ))}
                            </Field>
                        </bie.Col>
                    </bie.Row>

                    {/* ---------------- REPORT ---------------- */}

                    <div className="pt-3">
                        {rusaData?.length > 0 && (
                            <>

                                <div className='overal-stathead'>
                                    <span>Institute  Wise Financial Report</span>
                                </div>

                                <div className="all-table-content">
                                    <div className="table-responsive">
                                        <CommonReactTable
                                            data={rusaData}
                                            columns={RusaIColumns}
                                            filename="Institute Wise Financial Report"
                                            headerName="Institute Wise Financial Report"
                                            showFooter={true}
                                            showPagination={false}

                                        />
                                    </div>
                                </div>
                            </>
                        )}

                        {errormsg === false && (
                            <center className="text-danger mt-4 h5">
                                ***** No Data Found *****
                            </center>
                        )}
                    </div>

                </Form>
            </FormikProvider>
        </>
    );
}

export default CollegeFinancialContent;
